<template>
  <div class="actions-div">
    <p class="actions-text font-weight-bold">Actions</p>
    <v-row>
      <AssignCohort/>
      <v-col cols="5">
        <v-card class="actions-card">
          <v-card-actions class="text-center actions-btn" v-on:click="checkInAction">
            <v-btn text class="actions-btn-text">
              <v-img src="../../../../../../assets/svg/enroll.svg"></v-img>
              Check In
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
        <PaymentModal/>

     <WithdrawApplication/>
    </v-row>
    <v-row>
      <v-col cols="5">
        <v-card class="actions-card">
          <v-card-actions class="text-center actions-btn" v-on:click="confirmAction">
            <v-btn text class="actions-btn-text">
              <v-img src="../../../../../../assets/svg/receed.svg"></v-img>
              Rescind Interview Decision
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="5">
        <v-card class="actions-card">
          <v-card-actions class="text-center actions-btn" v-on:click="markApplicant">
            <v-btn class="actions-btn-text" text>
              <v-img src="../../../../../../assets/svg/withdraw.svg"></v-img>
              {{ markAsResponsiveButtonText() }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import PaymentModal from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/PaymentModal";
import AssignCohort from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/AssignCohort";
import axios from 'axios';
import {
  checkInNative,
  markApplicantAsNonResponsive,
  markApplicantAsResponsive,
  rescindInterview
} from "@/services/ApiServices";
import {mapGetters} from "vuex";
import WithdrawApplication from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/WithdrawApplication";

export default {
  name: "ActionsComponent",
  components: {WithdrawApplication, AssignCohort, PaymentModal},
  computed: {
    ...mapGetters(['applicantEmail', 'applicant'])
  },
  methods: {
  confirmAction() {
    if (confirm("Are you sure you want to rescind interview decision")) {
      const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
      axios.get(rescindInterview(this.applicantEmail), {headers: elderHeader})
          .then(res => {
            alert(res.data.message)
          })
          .catch(err => {
            alert(err.response.data.message)
          })

    }
  },
    markAsResponsiveButtonText() {
      if (this.applicant.applicationStatus === "NON_RESPONSIVE") {
        return "Mark as Responsive"
      } else {
        return "Mark as Non-Responsive"
      }
    },
    markApplicant() {
      console.log(this.applicant.applicationStatus);
      if (this.applicant.applicationStatus === "NON_RESPONSIVE") {
        this.markApplicantAsResponsive();
      } else {
        this.markApplicantAsNonResponsive();
      }
    },
    markApplicantAsNonResponsive() {
      console.log("I have been clicked")
      if (confirm("Are you sure you want to mark applicant as Non-Responsive?")) {
        const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
        axios.get(markApplicantAsNonResponsive(this.applicantEmail), {headers: elderHeader})
            .then(res => {
              alert(res.data.message)
            })
            .catch(err => {
              alert(err.response.data.message)
            })

      }
    },

    markApplicantAsResponsive() {
      console.log(this.applicant.applicationStatus)
      if (confirm("Are you sure you want to mark applicant as Responsive?")) {
        const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
        axios.get(markApplicantAsResponsive(this.applicantEmail), {headers: elderHeader})
            .then(res => {
              alert(res.data.message)
            })
            .catch(err => {
              console.log(err)
            })

      }
    },
    checkInAction() {
      if (this.applicant.applicationStatus === 'ENROLLED') {
        if (confirm("Are you sure you want to check this Applicant in ?")) {
          const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
          axios.post(checkInNative(this.applicantEmail), "", {headers: elderHeader})
              .then(res => {
                alert(res.data.message)
              })
              .catch(err => {
                console.log(err)
              })

        }
      }
    }
  }
}
</script>

<style scoped>
.actions-div{
  margin-top: 4%;
}
.actions-btn{
  padding-top: 30px;
  margin-left: 45px;
}
.actions-btn-text{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  color: #2B1C1C;
  text-transform: capitalize!important;
}
.actions-card{
  border-radius: 8px;
  background: #FFF2C7;
  height: 95px;
}
.actions-text{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 23px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;

  color: #960C0C;
}

</style>